module.exports = __webpack_public_path__ + "static/certificate-and-wheel-c4e4b9296b6e2b3fd3ed17d3becdc07e.png";